<template>
    <panel-template
        :module-name="moduleName"
        :title="product?.name || '-'"
        :active-header="false"
        :width-auto="true"
        :slot-page-list="$route.name === 'products.units'"
        :header-actions="true"
        background-color="#DDDCEC"
        :headerTitle="false"
        >

        <template #sidebar-left>
            <section class="container-sidebar-left">
                <div class="sidebar-left-header">
                    <div class="icon"><em class="fal fa-building" /></div>
                    <span class="title">
                        <ui-load-indicator
                            v-if="!product?.name"
                            :h="20"
                            :stroke="4"
                            bg-color="#DFE5EC"
                            color="#69D296"
                        />

                        <span v-else>{{ product?.name || '-' }}</span>
                    </span>
                </div>

                <div class="sidebar-left-links">
                    <div v-if="!product?.name" class="loader">
                        <ui-load-indicator
                            :h="50"
                            :stroke="4"
                            bg-color="#DFE5EC"
                            color="#69D296"
                        />
                    </div>

                    <template v-for="(link, i) in links" v-else>
                        <a
                            v-if="link.legacy"
                            :key="i"
                            :href="link.link"
                            :class="{ 'link-active': link.active }"
                            class="link"
                        >
                            {{ link.name }}
                            <em class="far fa-chevron-right" />
                        </a>
                        <router-link
                            v-else
                            :key="i"
                            :to="link.link"
                            :class="{ 'link-active': link.active }"
                            class="link"
                        >
                            {{ link.name }}
                            <em class="far fa-chevron-right" />
                        </router-link>
                    </template>
                </div>
            </section>
        </template>

        <template #page>
            <router-view />
        </template>

        <template v-if="$route.name == 'products.deploymentImage'" #sidebar-bottom>
            <div v-if="!summary.length" class="loading-footer-summary">
                <ui-load-indicator :h="40" :stroke="4" bg-color="#DFE5EC" color="#69D296" />
            </div>

            <section class="footer-deployment-image">
                <div v-for="(situation, index) in summary" :key="index" class="footer">
                    <span class="text">{{ situation.label }}: </span>
                    <span class="value">{{ situation.value_label }}</span>
                </div>
            </section>
        </template>
    </panel-template>
</template>

<script>
	import PanelTemplate from '@/templates/page-products'
    import { uiLoadIndicator, uiMenuCard } from '@/components/ui'

    import { mapGetters } from 'vuex'
    import store from '@/store'

    export default {
        name: 'ui-sales-mirror',

        components: {
            PanelTemplate,
            uiLoadIndicator,
            uiMenuCard
        },

        beforeRouteLeave(to, from, next) {
            // Antes de mudar a rota, limpa-se o dado da visualização anterior
            store.dispatch('product/clearVisualization').then(() => next())
        },

        computed: {
            ...mapGetters('product', {
                product: 'getProduct',
                summary: 'getSummary'
            }),
            /**
             * Computed property que retorna o link do painel Legado, referente a rota nova
             * do Painel Vue
             */
            oldLink() {
                let link = ''
                switch (this.$route.name) {
                    case 'products.units':
                        link = `/empreendimentos/${this.product?.id}/visualizar/lista`
                        break

                    case 'products.unitsHorizontal':
                        link = `/empreendimentos/${this.product?.id}/visualizar/eletronica`
                        break

                    case 'products.unitsVertical':
                        link = `/empreendimentos/${this.product?.id}/visualizar/vertical`
                        break

                    case 'products.deploymentImage':
                        link = `/empreendimentos/${this.product?.id}/visualizar/horizontal`
                        break
                }

                return link
            },
            /**
             * Computed property que retorna os menus a serem mostrados no sidebar
             */
            links() {
                const linksDefault = this.product
                    ? [
                        {
                            name: 'Dados do Empreendimento',
                            link: `/empreendimentos/${this.product?.id}/visualizar`,
                            active: false,
                            legacy: true,
                            show: true
                        },
                        {
                            name: 'Espelho Digital',
                            link: {
                                name: this.product?.availability?.type === 'horizontal'
                                    ? 'products.unitsHorizontal'
                                    : 'products.unitsVertical',
                                params: { id: this.product?.id || 0 }
                            },
                            active: [
                                'products.unitsHorizontal',
                                'products.unitsVertical'
                            ].includes(this.$route.name),
                            show: !(this.product?.infos?.hide_electronic_plant === true || 
                                    this.product?.infos?.hide_electronic_plant === 'true')
                        },
                        {
                            name: 'Imagem de Implantação',
                            link: { name: 'products.deploymentImage', params: { id: this.product?.id || 0 } },
                            active: this.$route.name === 'products.deploymentImage',
                            show: this.product.availability?.type === 'horizontal' && 
                                  !(this.product?.infos?.hide_sales_mirror === true || 
                                  this.product?.infos?.hide_sales_mirror === 'true')
                        },
                        {
                            name: 'Listar Unidades',
                            link: { name: 'products.units', params: { id: this.product?.id || 0 } },
                            active: this.$route.name === 'products.units',
                            show: true
                        }
                    ]
                    : []

                return linksDefault.filter(link => link.show)
            },
            /**
             * Computed property que define o título módulo/visualização acessada
             */
            moduleName() {
                let name = '-'
                switch (this.$route.name) {
                    case 'products.units':
                        name = 'Lista de Unidades'
                        break

                    case 'products.deploymentImage':
                        name = 'Imagem de Implantação'
                        break

                    case 'products.unitsHorizontal':
                        name = 'Espelho Digital Horizontal'
                        break

                    case 'products.unitsVertical':
                        name = 'Espelho Digital Vertical'
                        break
                }

                return name
            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>